module.exports = __webpack_public_path__ + "media/images/Header image - mobile-e5bbd4cc3505e02f6c94f3e81fb468a6.jpg";